import React from "react";
import { formatWhatsAppMarkupToHtml } from "../../utils/whatsappTextFormat";

/**
 * Renders WhatsApp-style formatted text (*bold*, **bold**, _italic_, etc.)
 */
const WhatsAppFormattedText = ({ text, className = "", as: Tag = "span" }) => {
  if (!text) return null;
  const html = formatWhatsAppMarkupToHtml(text);
  return (
    <Tag
      className={`break-words [overflow-wrap:anywhere] [&_a]:break-all ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default WhatsAppFormattedText;
